(() => {
  'use strict';
  let words = {};
  let view = 'back';
  let playing = true;
  let timer;
  const duration = 4000;
  const progress = new Set();
  const transitions = new WeakMap();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const all = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  function changePhoto(photo, color, nextView) {
    const picture = photo?.querySelector('img');
    if (!picture || (photo.dataset.color === color && photo.dataset.view === nextView)) return;
    const old = transitions.get(photo);
    old?.animation.cancel();
    old?.layer.remove();
    let layer;
    if (!motion.matches && picture.complete && picture.naturalWidth && typeof picture.animate === 'function') {
      const rect = photo.getBoundingClientRect();
      if (rect.top < innerHeight && rect.bottom > 0) {
        const crop = getComputedStyle(picture);
        const snapshot = picture.cloneNode(false);
        snapshot.removeAttribute('id');
        snapshot.removeAttribute('loading');
        snapshot.alt = '';
        snapshot.style.cssText = `position:absolute;width:${crop.width};height:${crop.height};max-width:none;left:${crop.left};top:${crop.top};transform:${crop.transform};transition:none;`;
        layer = document.createElement('span');
        layer.className = 'photo-transition-layer';
        layer.setAttribute('aria-hidden', 'true');
        layer.append(snapshot);
        photo.append(layer);
      }
    }
    photo.dataset.color = color;
    photo.dataset.view = nextView;
    if (layer) {
      const animation = layer.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 620, easing: 'ease-out', fill: 'forwards' });
      transitions.set(photo, { animation, layer });
      const finish = () => { layer.remove(); if (transitions.get(photo)?.layer === layer) transitions.delete(photo); };
      animation.finished.then(finish, finish);
    }
  }
  function paintView(nextView) {
    view = nextView;
    all('[data-auto-photo]').forEach(photo => changePhoto(photo, photo.dataset.color, view));
    const hero = document.querySelector('.hero');
    if (hero) hero.dataset.view = view;
    all('[data-hero-view], [data-collection-view]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.heroView || button.dataset.collectionView) === view)));
    const label = document.getElementById('hero-view-label');
    if (label) label.textContent = view === 'front' ? words.front_view : words.back_view;
  }
  function schedule() {
    clearTimeout(timer);
    progress.forEach(animation => animation.cancel());
    progress.clear();
    all('[data-toggle-auto]').forEach(button => {
      button.classList.toggle('is-playing', playing);
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', playing ? words.pause_label : words.play_label);
      const label = button.querySelector('.rotation-label');
      if (label) label.textContent = playing ? words.pause : words.play;
    });
    if (!playing || document.hidden || !document.querySelector('[data-auto-photo]')) return;
    if (!motion.matches) all('.auto-progress > span').forEach(bar => {
      if (typeof bar.animate === 'function') progress.add(bar.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration, easing: 'linear', fill: 'forwards' }));
    });
    timer = setTimeout(() => { paintView(view === 'front' ? 'back' : 'front'); schedule(); }, duration);
  }
  function updateVariant(select) {
    const option = select.selectedOptions[0];
    const section = select.closest('.om-product-page');
    if (!section || !option) return;
    const price = section.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    const button = section.querySelector('[data-add-button]');
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? words.sold_out : words.add_to_cart; }
    const picture = section.querySelector('[data-gallery-main-image]');
    if (picture && option.dataset.image) picture.src = option.dataset.image;
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  }
  function closeMenu() {
    const menu = document.getElementById('mobile-menu');
    const button = document.querySelector('.menu-trigger');
    if (menu) menu.hidden = true;
    button?.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-toggle-auto]')) { playing = !playing; schedule(); }
    if (target.matches('[data-hero-view], [data-collection-view]')) { paintView(target.dataset.heroView || target.dataset.collectionView); schedule(); }
    if (target.matches('[data-card-color]')) {
      const card = target.closest('[data-product-card]');
      const color = target.dataset.cardColor;
      all('[data-card-color]', card).forEach(button => button.setAttribute('aria-pressed', String(button === target)));
      changePhoto(card.querySelector('.product-photo'), color, view);
      card.querySelector('.color-label').textContent = words[color];
    }
    if (target.matches('[data-fit-tab]')) {
      const panel = target.closest('.fit-panel');
      const fit = target.dataset.fitTab;
      all('[data-fit-tab]', panel).forEach(button => button.setAttribute('aria-pressed', String(button === target)));
      [['.fit-number','initial'],['#fit-title','title'],['#fit-description','description'],['#fit-note','note']].forEach(([selector,key]) => { const node = panel.querySelector(selector); if (node) node.textContent = words[`${fit}_${key}`]; });
    }
    if (target.matches('.menu-trigger')) {
      const menu = document.getElementById('mobile-menu');
      menu.hidden = !menu.hidden;
      target.setAttribute('aria-expanded', String(!menu.hidden));
    } else if (target.closest('.mobile-menu')) closeMenu();
    if (target.matches('[data-gallery-thumbnail]')) {
      const section = target.closest('.om-product-page');
      const picture = section.querySelector('[data-gallery-main-image]');
      picture.src = target.dataset.src;
      picture.alt = target.dataset.alt || '';
      all('[data-gallery-thumbnail]', section).forEach(button => button.classList.toggle('is-active', button === target));
    }
  });
  document.addEventListener('change', event => { if (event.target.matches('[data-variant-select]')) updateVariant(event.target); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('shopify:section:load', () => { paintView(view); schedule(); });
  document.addEventListener('shopify:section:unload', schedule);
  motion.addEventListener('change', schedule);
  addEventListener('pagehide', () => { clearTimeout(timer); progress.forEach(animation => animation.cancel()); });
  addEventListener('pageshow', schedule);
  matchMedia('(min-width: 761px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
  let scrollPending = false;
  addEventListener('scroll', () => {
    if (scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(() => {
      const bar = document.querySelector('.scroll-progress');
      const max = document.documentElement.scrollHeight - innerHeight;
      if (bar) bar.style.width = `${max > 0 ? scrollY / max * 100 : 0}%`;
      scrollPending = false;
    });
  }, { passive: true });
  function init() {
    try { words = JSON.parse(document.getElementById('om-translations')?.textContent || '{}'); }
    catch { words = {}; }
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
